// extracted by mini-css-extract-plugin
module.exports = {"smallMarg":"intro-module--smallMarg--MQ7Ov","pageHeadline":"intro-module--pageHeadline--3zLDs"};